import React from 'react';

const FilterStoresDropdown = ({ className = "" }) => {
  return (
    <div className={`dropdown ${className}`}>
      <button
        className="btn dropdown-toggle"
        type="button"
        id="filterStoresDropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        style={{
          backgroundColor: '#fff',
          border: '1px solid #D0D5DD',
          color: '#111827',
          borderRadius: '8px',
          padding: '8px 16px',
          fontSize: '14px',
          fontWeight: '500'
        }}
      >
        <img src="/assets/icons/filterlines.svg" alt="" style={{ width: '16px', marginRight: '8px' }} />
        Filter Stores
      </button>
      <div className="dropdown-menu" aria-labelledby="filterStoresDropdown" style={{ minWidth: '250px', padding: '12px' }}>
        <div className="mb-2">
          <h6 style={{ fontSize: '14px', fontWeight: '600', margin: '0 0 8px 0', color: '#111827' }}>Select Stores</h6>
        </div>
        <div className="form-check mb-2">
          <input className="form-check-input" type="checkbox" value="all" id="allStores" defaultChecked style={{ accentColor: '#AF3585' }} />
          <label className="form-check-label" htmlFor="allStores" style={{ fontSize: '14px', color: '#111827' }}>
            All Stores
          </label>
        </div>
        <div className="form-check mb-2">
          <input className="form-check-input" type="checkbox" value="store1" id="store1" style={{ accentColor: '#AF3585' }} />
          <label className="form-check-label" htmlFor="store1" style={{ fontSize: '14px', color: '#111827' }}>
            Prince Ebano - Egbeda
          </label>
        </div>
        <div className="form-check mb-2">
          <input className="form-check-input" type="checkbox" value="store2" id="store2" style={{ accentColor: '#AF3585' }} />
          <label className="form-check-label" htmlFor="store2" style={{ fontSize: '14px', color: '#111827' }}>
            Prince Ebano - Isolo
          </label>
        </div>
        <div className="form-check mb-2">
          <input className="form-check-input" type="checkbox" value="store3" id="store3" style={{ accentColor: '#AF3585' }} />
          <label className="form-check-label" htmlFor="store3" style={{ fontSize: '14px', color: '#111827' }}>
            Prince Ebano - Ajah
          </label>
        </div>
        <hr style={{ margin: '12px 0' }} />
        <div className="d-flex justify-content-between">
          <button
            className="btn btn-sm"
            style={{
              backgroundColor: '#fff',
              border: '1px solid #D0D5DD',
              color: '#111827',
              fontSize: '12px',
              padding: '4px 12px'
            }}
          >
            Clear All
          </button>
          <button
            className="btn btn-sm"
            style={{
              backgroundColor: '#AF3585',
              border: '1px solid #AF3585',
              color: '#fff',
              fontSize: '12px',
              padding: '4px 12px'
            }}
          >
            Apply Filter
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterStoresDropdown;
